module.exports = __webpack_public_path__ + "79e82b01e807186e1d1c33793aea3f71.png";